export default __webpack_public_path__ + "static/media/card-website-icon.0be0ca79.png";